module.exports = __webpack_public_path__ + "static/media/input.7c5abcf1.png";